/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.util

/**
 * Domain-specific errors that originate from business rules rather than
 * network or infrastructure failures. These carry structured data only —
 * user-facing messages are resolved at the presentation layer via
 * localized string resources.
 */
sealed class BusinessError(message: String? = null) : Exception(message) {

    /**
     * The user has reached the maximum allowed count for a given resource
     * type under their current subscription tier.
     */
    data class LimitReached(val resourceType: String) : BusinessError()

    /**
     * A field failed domain validation that cannot be expressed as a
     * simple UI-level check (e.g. server-side uniqueness).
     */
    data class ValidationFailed(
        val field: String,
        val reason: String,
    ) : BusinessError()

    /**
     * No authenticated user session is available when one is required.
     */
    data object NotAuthenticated : BusinessError()
}
